import { cn } from '@/lib/utils';

export function AdminSidebarItems<T extends { id: number }>({
  data,
  selectedId,
  onSelect,
  displayField,
  testId,
}: {
  data: T[];
  selectedId: number | null;
  onSelect: (id: number) => void;
  displayField: keyof T;
  testId: string;
}) {
  return (
    <div className="space-y-0.5">
      {data.map((item, index) => {
        const isSelected = selectedId === item.id;

        return (
          <div
            key={item.id}
            data-testid={testId}
            onClick={() => onSelect(item.id)}
            className={cn(
              'relative flex items-center rounded-md px-3 py-2 cursor-pointer transition-all duration-150',
              'text-sm',
              isSelected
                ? 'bg-primary text-primary-foreground font-medium'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted/80'
            )}
          >
            {/* Number indicator */}
            <span
              className={cn(
                'mr-3 text-xs font-mono',
                isSelected
                  ? 'text-primary-foreground/70'
                  : 'text-muted-foreground/50'
              )}
            >
              {String(index + 1).padStart(2, '0')}
            </span>

            {/* Content */}
            <span className="truncate">{String(item[displayField])}</span>

            {/* Active dot indicator */}
            {isSelected && (
              <div
                className="absolute right-2 top-1/2 -translate-y-1/2 w-1.5
   h-1.5 bg-primary-foreground rounded-full"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
